/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Order: "enum" as const,
	Upload: `scalar.Upload` as const,
	Query:{
		address_combos:{

		},
		address_cities:{

		},
		address_from_cep:{

		},
		address_installation:{

		},
		customer_form:{

		},
		access_user_credentials:{

		},
		credentials_check:{

		},
		documents:{

		},
		financing:{

		},
		financingV2:{

		},
		financings:{
			input:"FinancingsInput"
		},
		financing_type:{

		},
		formalization:{

		},
		formalization_biometry_confirm:{

		},
		formalization_v2:{

		},
		formalization_metrics:{

		},
		targetIncentivesSummary:{

		},
		getCommissioningStatus:{

		},
		installation:{

		},
		mirrorStatus:{

		},
		available_orders:{

		},
		legacyFinancing:{

		},
		notifications:{

		},
		partner:{

		},
		partners:{
			input:"CoreGetPartnersInput"
		},
		payment_current_issuance_model:{

		},
		projects_partner_overview:{

		},
		project:{

		},
		project_proposal_changes:{

		},
		project_is_combo:{

		},
		registration:{

		},
		registration_grid_access_approval:{

		},
		risk_financing_revalidations:{
			input:"RevalidationsInput"
		},
		getOpportunities:{
			params:"GetOpportunitiesInput"
		},
		simulation_project_shopping_cart_id_get:{

		},
		wallet_payment_model:{

		}
	},
	PersonTypes: "enum" as const,
	DocumentTypes: "enum" as const,
	LegalRepresentantTypes: "enum" as const,
	CustomerStatus: "enum" as const,
	RegistrationV2PersonType: "enum" as const,
	CustomerRegistrationAddress:{

	},
	CustomerRegistrationContact:{

	},
	CustomerRegistrationDocument:{

	},
	CustomerRegistrationCustomer:{
		contact:"CustomerRegistrationContact",
		documents:"CustomerRegistrationDocument",
		address:"CustomerRegistrationAddress"
	},
	CustomerRegistrationGuarantor:{
		contact:"CustomerRegistrationContact",
		documents:"CustomerRegistrationDocument",
		address:"CustomerRegistrationAddress"
	},
	CustomerRegistrationElectricityBill:{

	},
	CustomerRegistrationElectricityBillWithDocuments:{

	},
	CustomerRegistrationProject:{
		address:"CustomerRegistrationAddress",
		documents:"CustomerRegistrationDocument",
		electricity_bill:"CustomerRegistrationElectricityBill",
		electricity_bills:"CustomerRegistrationElectricityBillWithDocuments"
	},
	CustomerRegistrationCompany:{
		contact:"CustomerRegistrationContact",
		documents:"CustomerRegistrationDocument",
		majority_partner:"CustomerRegistrationCustomer",
		legal_representatives:"CustomerRegistrationLegalRepresentative"
	},
	CustomerRegistrationLegalRepresentative:{
		contact:"CustomerRegistrationContact",
		documents:"CustomerRegistrationDocument",
		address:"CustomerRegistrationAddress"
	},
	CustomerRegistrationInput:{
		person_type:"RegistrationV2PersonType",
		customer:"CustomerRegistrationCustomer",
		guarantor:"CustomerRegistrationGuarantor",
		project:"CustomerRegistrationProject",
		company:"CustomerRegistrationCompany",
		electricity_bills:"CustomerRegistrationElectricityBillWithDocuments"
	},
	Person:{

	},
	PersonInput:{

	},
	RegistrationContactChangeInput:{
		customer:"PersonInput",
		guarantor:"PersonInput",
		majority_partner:"PersonInput",
		legal_representative_1:"PersonInput",
		legal_representative_2:"PersonInput"
	},
	Mutation:{
		registration_contact_change:{
			input:"RegistrationContactChangeInput"
		},
		customer_document_upload:{
			documents:"Upload"
		},
		customer_document_form_analysis_cancel:{

		},
		customer_registration:{
			params:"CustomerRegistrationInput"
		},
		register_device_orchestrator_gateway_credential:{
			input:"RegisterDeviceOrchestratorGatewayCredentialInput"
		},
		device_orchestrator_credentials_change:{

		},
		formalization_term_combo_connect_resend:{

		},
		validateHardwareForm:{
			hardwareFormInput:"HardwareFormInput"
		},
		hardware_form_showcase:{
			hardwareFormShowcaseInput:"HardwareFormShowcaseInput"
		},
		hardware_form_draft:{
			hardwareFormDraftInput:"HardwareDraft"
		},
		installation_mirror_upload:{
			mirror:"Upload"
		},
		installation_inverter_labels_upload:{
			inverterLabel:"Upload",
			dataloggerLabel:"Upload"
		},
		installation_power_inverters_validate:{
			input:"ValidateTotalInvertersPowerInput"
		},
		installation_section_delete:{

		},
		installation_section_document_delete:{

		},
		installation_customer_reproval:{
			input:"CustomerReprovalInput"
		},
		installation_installed_inverter_create:{
			input:"CreateInstalledInverterInput"
		},
		installation_installed_inverter_create_with_brand:{
			input:"CreateInstalledInverterWithBrandInput"
		},
		installation_commissioning_check:{

		},
		installation_commissioning_request:{
			input:"CommissioningRequestInput"
		},
		installation_commissioning_reset_customer_rejection:{

		},
		installation_biometric_validation:{
			input:"BiometricValidationInput"
		},
		markNotificationsRead:{

		},
		markNotificationClicked:{

		},
		project_update_shopping_cart:{

		},
		project_proposal_update:{
			payload:"ProjectProposalUpdatePayloadInput"
		},
		project_create:{
			input:"ProjectCreateInput"
		},
		registration:{
			params:"RegistrationUpdateInput"
		},
		risk_financing_register_credential:{
			input:"RegisterRevalidationCredentialInput"
		},
		risk_financing_submit_revalidations:{
			input:"SubmitRevalidationsInput"
		},
		processEnergyAccountAnalysis:{
			params:"AnalyzeEnergyBillInput"
		}
	},
	JSON: `scalar.JSON` as const,
	DeviceOrchestratorGatewayCredentialErrorCode: "enum" as const,
	RegisterDeviceOrchestratorGatewayCredentialInput:{

	},
	PersonType: "enum" as const,
	FinancingStatus: "enum" as const,
	FinancingSteps: "enum" as const,
	StatusList: "enum" as const,
	FinancingsInput:{
		status:"FinancingStatus",
		steps:"FinancingSteps"
	},
	FileStatusType: "enum" as const,
	DocumentStatusType: "enum" as const,
	TypeSection: "enum" as const,
	MirrorStatuses: "enum" as const,
	HardwareFormInverter:{

	},
	HardwareFormModule:{

	},
	HardwareFormComboEquipment:{

	},
	HardwareFormBatteries:{

	},
	HardwareFormComboMetadata:{
		inverters:"HardwareFormComboEquipment",
		modules:"HardwareFormComboEquipment"
	},
	HardwareFormInput:{
		inverters:"HardwareFormInverter",
		modules:"HardwareFormModule",
		batteries:"HardwareFormBatteries",
		combo_metadata:"HardwareFormComboMetadata"
	},
	HardwareFormShowcaseInput:{
		inverters:"HardwareFormInverter",
		modules:"HardwareFormModule"
	},
	ValidateTotalInvertersPowerInput:{

	},
	CustomerReprovalInput:{

	},
	BiometricValidationInput:{

	},
	BiometricValidationStatus: "enum" as const,
	BiometricValidationReason: "enum" as const,
	HardwareDraftEquipment:{

	},
	HardwareDraft:{
		inverters:"HardwareDraftEquipment",
		modules:"HardwareDraftEquipment"
	},
	CreateInstalledInverterInput:{

	},
	CreateInstalledInverterWithBrandInput:{

	},
	InstalledInverterGlobalStatus: "enum" as const,
	InstalledInverterStatus: "enum" as const,
	CommissioningCheckStatus: "enum" as const,
	CommissioningMonitoringStatus: "enum" as const,
	CommissioningFailureReason: "enum" as const,
	MonitoringInput:{

	},
	CommissioningRequestInput:{
		monitorings:"MonitoringInput"
	},
	CommissioningInstallationStatus: "enum" as const,
	CoreGetPartnersInput:{

	},
	ProjectPersonType: "enum" as const,
	ProjectSystemType: "enum" as const,
	ProjectProposalUpdatePayloadInput:{

	},
	ProjectCreateInput:{
		person_type:"ProjectPersonType",
		system_type:"ProjectSystemType"
	},
	ProjectCreateStatus: "enum" as const,
	RegistrationPersonType: "enum" as const,
	RegistrationDocumentTypes: "enum" as const,
	RegistrationRepresentantTypes: "enum" as const,
	RegistrationDocumentModel: "enum" as const,
	RegistrationUpdateInput:{

	},
	GridAccessApprovalDisplayMode: "enum" as const,
	RevalidationStatus: "enum" as const,
	AttemptStatus: "enum" as const,
	RevalidationsInput:{
		status:"RevalidationStatus"
	},
	RegisterRevalidationCredentialInput:{

	},
	RegisterRevalidationCredentialErrorCode: "enum" as const,
	RevalidationSubmissionDeviceInput:{

	},
	RevalidationSubmissionInput:{
		devices:"RevalidationSubmissionDeviceInput"
	},
	SubmitRevalidationsInput:{
		submissions:"RevalidationSubmissionInput"
	},
	AnalyzeEnergyBillInput:{

	},
	GetOpportunitiesInput:{

	}
}

export const ReturnTypes: Record<string,any> = {
	Upload: `scalar.Upload` as const,
	Combos:{
		data:"ComboData"
	},
	Cities:{
		data:"CityStateData"
	},
	AddressInstallation:{
		data:"AddressInstallationData"
	},
	ComboData:{
		nationality:"CityStateData",
		gender:"CityStateData",
		occupation:"CityStateData",
		state:"CityStateData"
	},
	CepAddress:{
		neighborhood:"String",
		street:"String",
		state:"CityStateData",
		city:"CityStateData"
	},
	AddressInstallationData:{
		postal_code:"String",
		street:"String",
		street_number:"Int",
		additional_info:"String",
		neighborhood:"String",
		city:"String",
		state:"String",
		rural_area:"Boolean"
	},
	CityStateData:{
		name:"String",
		id:"String"
	},
	Query:{
		address_combos:"Combos",
		address_cities:"Cities",
		address_from_cep:"CepAddress",
		address_installation:"AddressInstallation",
		customer_form:"CustomerFormResponse",
		access_user_credentials:"AccessUserCredentialsResponse",
		credentials_check:"CredentialsCheckResponse",
		documents:"DocumentResponse",
		financing:"Financing",
		financingV2:"FinancingV2",
		financings:"FinancingsList",
		financing_type:"FinancingType",
		formalization:"FormalizationInfo",
		formalization_biometry_confirm:"ConfirmBiometryResponse",
		formalization_v2:"FormalizedFinancing",
		formalization_metrics:"FormalizationMetricsResponse",
		targetIncentivesSummary:"TargetIncentiveSummary",
		getCommissioningStatus:"CommissioningStatusResponse",
		installation:"Installation",
		mirrorStatus:"MirrorStatus",
		inverter_brands:"InverterBrands",
		available_orders:"AvailableOrders",
		legacyFinancing:"LegacyFinancing",
		notifications:"NotificationsList",
		partner:"OnlyPartner",
		partners:"CorePartner",
		payment_current_issuance_model:"PaymentCurrentIssuanceModel",
		projects_partner_overview:"PartnerOverview",
		project:"Project",
		project_proposal_changes:"ProjectProposal",
		project_is_combo:"IsComboResponse",
		project_system_types:"String",
		registration:"RegistrationDetailsResponse",
		registration_grid_access_approval:"RegistrationGridAccessApproval",
		risk_financing_revalidation_summary:"RevalidationSummary",
		risk_financing_revalidations:"RevalidationsListResponse",
		getOpportunities:"GetOpportunitiesResponse",
		simulation_project_shopping_cart_id_get:"String",
		user:"User",
		wallet_payment_model:"WalletPaymentModel"
	},
	RegistrationContactChangeResponse:{
		message:"String",
		status:"Int"
	},
	CustomerFormResponse:{
		project_id:"String",
		is_combo:"Boolean",
		person_type:"PersonTypes",
		customer:"CustomerData",
		guarantor:"CustomerData",
		project:"CustomerProject",
		remaining_changes_after_confirmation:"Int",
		company:"CompanyData",
		errors:"CustomerErrors",
		status:"CustomerStatus"
	},
	CustomerErrors:{
		field:"String",
		title:"String",
		description:"String"
	},
	CustomerContact:{
		email:"String",
		phone:"String"
	},
	CustomerDocument:{
		type:"DocumentTypes",
		status:"String",
		filename:"String",
		url_download:"String",
		url_preview:"String",
		mime_type:"String",
		id:"String"
	},
	CustomerAddress:{
		zipcode:"String",
		street:"String",
		street_number:"String",
		complement:"String",
		neighborhood:"String",
		city_id:"Int",
		state_id:"Int",
		city:"CustomerIdName",
		state:"CustomerIdName",
		is_rural:"Boolean"
	},
	CustomerData:{
		cpf:"String",
		full_name:"String",
		birthdate:"String",
		contact:"CustomerContact",
		documents:"CustomerDocument",
		document_type:"String",
		comment:"String",
		address:"CustomerAddress"
	},
	CustomerEletricityBill:{
		is_under_customer_name:"Boolean",
		holder_cpf:"String",
		distributor_id:"Int"
	},
	CustomerProject:{
		address:"CustomerAddress",
		documents:"CustomerDocument",
		document_type:"String",
		comment:"String",
		electricity_bill:"CustomerEletricityBill",
		residencial_is_the_same_of_plant:"Boolean"
	},
	CompanyMajorityPartner:{
		cpf:"String",
		full_name:"String",
		birthdate:"String",
		contact:"CustomerContact",
		documents:"CustomerDocument",
		document_type:"String",
		comment:"String",
		address:"CustomerAddress"
	},
	CompanyLegalRepresentant:{
		kind:"LegalRepresentantTypes",
		cpf:"String",
		full_name:"String",
		birthdate:"String",
		contact:"CustomerContact",
		documents:"CustomerDocument",
		document_type:"String",
		comment:"String",
		address:"CustomerAddress"
	},
	CompanyData:{
		company_name:"String",
		cnpj:"String",
		contact:"CustomerContact",
		documents:"CustomerDocument",
		document_type:"String",
		comment:"String",
		majority_partner:"CompanyMajorityPartner",
		majority_partner_is_legal_representative:"Boolean",
		is_only_one_legal_representative:"Boolean",
		legal_representatives:"CompanyLegalRepresentant"
	},
	CustomerIdName:{
		id:"Int",
		name:"String"
	},
	CustomerDocumentUpload:{
		id:"String",
		url:"String",
		url_inline:"String",
		filename:"String",
		mimetype:"String",
		size:"Int",
		docstorage_id:"String",
		created_at:"String"
	},
	CustomerRegistrationError:{
		field:"String",
		message:"String",
		type:"String",
		title:"String",
		description:"String"
	},
	CustomerRegistrationV2Response:{
		errors:"CustomerRegistrationError"
	},
	CustomerDocumentFormAnalysis:{
		id:"String",
		status:"String",
		project_id:"String",
		installation_document_matches_bill:"Boolean",
		installation_address_matches_bill:"Boolean",
		identity_matches_document:"Boolean",
		reason:"String",
		comments:"String",
		documents:"CustomerDocumentUpload"
	},
	Mutation:{
		registration_contact_change:"RegistrationContactChangeResponse",
		customer_document_upload:"CustomerDocumentUpload",
		customer_document_form_analysis_cancel:"CustomerDocumentFormAnalysis",
		customer_registration:"CustomerRegistrationV2Response",
		register_device_orchestrator_gateway_credential:"RegisterDeviceOrchestratorGatewayCredentialResponse",
		device_orchestrator_credentials_change:"RegisterDeviceOrchestratorGatewayCredentialResponse",
		formalization_term_combo_connect_resend:"TermComboConnectResponse",
		validateHardwareForm:"HardwareFormValidation",
		hardware_form_showcase:"HardwareFormShowcaseResponse",
		hardware_form_draft:"String",
		installation_mirror_upload:"MirrorUploadResponse",
		installation_inverter_labels_upload:"UploadInstallationLabelsResponse",
		installation_power_inverters_validate:"ValidateTotalInvertersPowerResponse",
		installation_section_delete:"Boolean",
		installation_section_document_delete:"Boolean",
		installation_customer_reproval:"Boolean",
		installation_installed_inverter_create:"CreatedInstalledInverter",
		installation_installed_inverter_create_with_brand:"CreatedInstalledInverter",
		installation_commissioning_check:"CommissioningCheckResponse",
		installation_commissioning_request:"CommissioningRequestResponse",
		installation_commissioning_reset_customer_rejection:"CommissioningResetResponse",
		installation_biometric_validation:"BiometricValidationResponse",
		markNotificationsRead:"Boolean",
		markNotificationClicked:"Boolean",
		project_update_shopping_cart:"ID",
		project_proposal_update:"Boolean",
		project_create:"ProjectCreateResponse",
		registration:"Boolean",
		risk_financing_register_credential:"RegisterRevalidationCredentialResponse",
		risk_financing_submit_revalidations:"SubmitRevalidationsResponse",
		processEnergyAccountAnalysis:"EnergyBillAnalysisDecision"
	},
	JSON: `scalar.JSON` as const,
	RegisterDeviceOrchestratorGatewayCredentialResponse:{
		success:"Boolean",
		message:"DeviceOrchestratorGatewayCredentialErrorCode"
	},
	AccessUserCredentialsData:{
		access_user:"String",
		platform:"String",
		partner_id:"Int"
	},
	AccessUserCredentialsResponse:{
		success:"Boolean",
		message:"String",
		data:"AccessUserCredentialsData"
	},
	CredentialsCheckResponse:{
		has_credentials:"Boolean",
		is_valid:"Boolean",
		access_token:"String"
	},
	DocumentResponse:{
		data:"DocumentData"
	},
	DocumentData:{
		project:"Documents",
		customer:"Documents",
		guarantor:"DocumentFile",
		company:"DocumentFile"
	},
	Documents:{
		id:"String",
		docstorage_id:"String",
		kind:"String",
		validated_at:"String",
		validation_mode:"String",
		deleted_at:"String",
		submitted_at:"String",
		canceled_at:"String",
		status:"String",
		reason:"DocumentReason",
		file:"DocumentFile"
	},
	DocumentFile:{
		public_id:"String",
		filename:"String",
		mimetype:"String",
		size:"Int",
		url:"String",
		url_inline:"String"
	},
	DocumentReason:{
		title:"String",
		description:"String"
	},
	FinancingV2:{
		id:"Int",
		project_id:"String",
		financed_value:"Float",
		customer_name:"String",
		document:"String",
		expires_at:"String",
		created_at:"String",
		formalized_at:"String",
		installed_at:"String",
		status:"FinancingStatus",
		step:"String",
		is_combo:"Boolean",
		is_combo_connect:"Boolean",
		payments:"Payment",
		flow_provider:"String",
		person_type:"PersonType",
		all_payments_sent:"Boolean",
		section_statuses:"FinancingSectionStatusesV2",
		updated_at:"String",
		is_expired:"Boolean",
		system_power:"Float",
		system_type:"String",
		inverters_power_kw:"Float",
		new_journey:"Boolean",
		legacy_id:"Int",
		reason:"String",
		openable_steps:"FormalizationStatuses",
		is_aproved:"Boolean",
		is_final:"Boolean"
	},
	FinancingSectionStatusesV2:{
		simulation:"FinancingStep",
		installation:"FinancingStep",
		customer_data:"FinancingStep",
		equipment:"FinancingStep",
		biometry_and_contract:"BiometryAndContractStep",
		payment_model:"FinancingStep"
	},
	GenericFinancingStep:{
		"...on FinancingStep": "FinancingStep",
		"...on BiometryAndContractStep": "BiometryAndContractStep",
		completed_at:"String",
		reproved_at:"String",
		status:"String",
		submitted_at:"String"
	},
	FinancingStep:{
		completed_at:"String",
		reproved_at:"String",
		status:"String",
		submitted_at:"String"
	},
	MetadataItem:{
		completed_at:"String",
		first_submitted_at:"String",
		last_submitted_at:"String"
	},
	BiometryAndContractMetadata:{
		biometry:"MetadataItem",
		contract:"MetadataItem",
		term:"MetadataItem"
	},
	BiometryAndContractStep:{
		completed_at:"String",
		reproved_at:"String",
		status:"String",
		submitted_at:"String",
		metadata:"BiometryAndContractMetadata"
	},
	Payment:{
		id:"Int",
		financing_id:"Float",
		value:"Float",
		total_value:"Float",
		payment_percentage:"Float",
		created_at:"String"
	},
	Financing:{
		id:"Int",
		project_id:"String",
		financed_value:"Float",
		project_value:"Float",
		customer_name:"String",
		document:"String",
		expires_at:"String",
		created_at:"String",
		formalized_at:"String",
		installed_at:"String",
		status:"FinancingStatus",
		step:"String",
		is_combo:"Boolean",
		is_combo_connect:"Boolean",
		payments:"Payment",
		flow_provider:"String",
		person_type:"PersonType",
		all_payments_sent:"Boolean",
		section_statuses:"FinancingSectionStatus",
		updated_at:"String",
		is_expired:"Boolean",
		system_power:"Float",
		new_journey:"Boolean",
		legacy_id:"Int",
		reason:"String",
		openable_steps:"FormalizationStatuses",
		is_aproved:"Boolean",
		is_final:"Boolean",
		loan_value:"Float"
	},
	FormalizationStatuses:{
		hardware:"Boolean",
		registration:"Boolean",
		documentation:"Boolean",
		contract:"Boolean",
		receiptModel:"Boolean"
	},
	FinancingProposal:{
		customer_data:"String",
		equipment:"String",
		biometry_and_contract:"String",
		payment_model:"String"
	},
	FinancingFormalization:{
		contract:"String",
		hardware:"String",
		registration:"String",
		documentation:"String",
		receipt_model:"String"
	},
	FinancingSectionStatus:{
		concluded:"String",
		simulation:"String",
		installation:"String",
		proposal:"FinancingProposal",
		formalization:"FinancingFormalization"
	},
	FinancingsList:{
		data:"Financing",
		has_next:"Boolean",
		statuses:"StatusList",
		all_steps:"Item"
	},
	Item:{
		name:"String",
		value:"String"
	},
	FinancingType:{
		max_financing_value:"Float",
		min_financing_value:"Float",
		max_financing_installments:"Int",
		grace_period_financing:"GracePeriod",
		max_bnpl_value:"Float",
		max_bnpl_installments:"Int",
		grace_period_bnpl:"GracePeriod"
	},
	GracePeriod:{
		label:"String",
		value:"Int"
	},
	FormalizationInfo:{
		approval:"String",
		biometry:"Biometry",
		cancel:"Boolean",
		contract:"Contract",
		cancellation_type:"String",
		contracts:"FormalizationContracts",
		term:"Term",
		download:"Download",
		order_id:"String",
		pendencies:"Pendencies",
		remaining_contract_days_until_expiration:"Int",
		resend:"Boolean",
		send_biometry_contract:"SendBiometryContract",
		status:"String",
		status_reason:"FormalizationStatusReason"
	},
	FormalizationStatusReason:{
		code:"String",
		description:"String"
	},
	Biometry:{
		pending:"Boolean",
		signers:"Signer",
		status:"String"
	},
	Contract:{
		has_biometric:"Boolean",
		signers:"ContractSigner",
		status:"String"
	},
	FormalizationContractSection:{
		status:"String",
		document_signed:"String",
		signers:"ContractSigner"
	},
	FormalizationContracts:{
		financing_amendment_term:"FormalizationContractSection",
		loan:"FormalizationContractSection",
		lender_insurance:"FormalizationContractSection",
		diverse_risks_insurance:"FormalizationContractSection",
		combo_connect_term:"FormalizationContractSection"
	},
	Term:{
		signers:"ContractSigner",
		status:"String"
	},
	Signer:{
		name:"String",
		checked:"Boolean",
		status:"String"
	},
	ContractSigner:{
		name:"String",
		checked:"Boolean"
	},
	Download:{
		contract:"String",
		insurance:"String",
		term:"String"
	},
	Pendencies:{
		expired_at:"String",
		items:"PendencyItem"
	},
	PendencyItem:{
		category:"String",
		message:"String"
	},
	SendBiometryContract:{
		message:"BiometryMessage",
		method_receipt:"String"
	},
	BiometryMessage:{
		days:"Int",
		time:"Int"
	},
	ConfirmBiometryResponse:{
		is_done:"Boolean"
	},
	TermComboConnectResponse:{
		success:"Boolean",
		message:"String"
	},
	FormalizedFinancing:{
		id:"Int",
		new_journey:"Boolean",
		project_id:"String",
		partner_commission_percent:"Float",
		financing_line:"String",
		company:"FormalizedFinancingCompany",
		customer:"FormalizedFinancingCustomer",
		guarantor:"FormalizedFinancingGuarantor",
		legal_representatives:"FormalizedFinancingLegalRepresentative",
		majority_partner:"FormalizedFinancingMajorityPartner",
		proposal:"FormalizedFinancingProposal",
		contract:"FormalizedFinancingContract",
		partner:"FormalizedFinancingPartner",
		securitization:"FormalizedFinancingSecuritization",
		funding:"String",
		project:"FormalizedFinancingProject"
	},
	FormalizedFinancingCustomer:{
		address:"FormalizedFinancingCustomerAddress",
		birthdate:"String",
		contact:"FormalizedFinancingCustomerContact",
		cpf:"String",
		full_name:"String"
	},
	FormalizedFinancingCustomerAddress:{
		city:"String",
		complement:"String",
		neighborhood:"String",
		state:"String",
		street:"String",
		street_number:"String",
		zipcode:"String"
	},
	FormalizedFinancingCustomerContact:{
		email:"String",
		phone:"String"
	},
	FormalizedFinancingContract:{
		banking:"String",
		ccb_number:"String",
		formalized_at:"String",
		generate_date:"String",
		signed_date:"String"
	},
	FormalizedFinancingPartner:{
		id:"ID",
		cnpj:"String",
		company_name:"String",
		payment_institution:"String"
	},
	FormalizedFinancingProposal:{
		installments_number:"Int",
		rate_type:"String",
		installment_amount:"Float",
		gross_amount:"Float",
		down_payment:"Float",
		grace_period:"Int",
		registration_fee:"Float",
		interest_fee:"Float",
		iof:"Float",
		ipca_type:"String",
		cet:"Float"
	},
	FormalizedFinancingSecuritization:{
		cnpj:"String",
		slug:"String",
		corporate_name:"String",
		name:"String"
	},
	FormalizedFinancingProject:{
		electrical_phase:"String",
		installed_at:"String",
		inverter_type:"String",
		inverters:"FormalizedFinancingInverter",
		modules:"FormalizedFinancingModule",
		total_powers:"FormalizedFinancingTotalPowers"
	},
	FormalizedFinancingInverter:{
		brand:"String",
		contactor_switch:"String",
		model:"String",
		phase:"String",
		power:"Float",
		voltage:"Int",
		quantity:"Int"
	},
	FormalizedFinancingModule:{
		brand:"String",
		model:"String",
		phase:"String",
		power:"Float",
		voltage:"Int",
		quantity:"Int"
	},
	FormalizedFinancingTotalPowers:{
		system:"Float",
		modules:"Float",
		inverters:"Float"
	},
	FormalizedFinancingCompany:{
		company_name:"String",
		cnpj:"String"
	},
	FormalizedFinancingGuarantor:{
		full_name:"String",
		cpf:"String"
	},
	FormalizedFinancingMajorityPartner:{
		full_name:"String",
		cpf:"String",
		percentage:"Float",
		contact:"FormalizedFinancingCustomerContact"
	},
	FormalizedFinancingLegalRepresentative:{
		full_name:"String",
		cpf:"String",
		role:"String"
	},
	FormalizationBucket:{
		amount:"Float",
		count:"Int",
		pct:"Float"
	},
	FormalizationBuckets:{
		lte_45:"FormalizationBucket",
		d46_60:"FormalizationBucket",
		d61_90:"FormalizationBucket",
		gt_90:"FormalizationBucket",
		lte_60:"FormalizationBucket",
		lte_90:"FormalizationBucket"
	},
	FormalizationIntegratorMetrics:{
		partner_id:"String",
		partner_name:"String",
		total_formalized:"Int",
		total_formalized_in_window:"Int",
		total_installed:"Int",
		total_installed_in_window:"Int",
		buckets:"FormalizationBuckets",
		buckets_pending:"FormalizationBuckets"
	},
	FormalizationMetricsResponse:{
		window_days:"Int",
		items:"FormalizationIntegratorMetrics",
		has_next:"Boolean"
	},
	Incentive:{
		title_ptbr:"String",
		description_ptbr:"String",
		banner_url:"String"
	},
	TargetIncentiveSummary:{
		campaign_id:"String",
		incentive:"Incentive"
	},
	Status:{
		description:"String",
		id:"Int",
		slug:"DocumentStatusType"
	},
	Document:{
		filename:"String",
		filetype:"String",
		id:"String",
		status:"Status",
		type:"String",
		url:"String"
	},
	Section:{
		documents:"Document",
		id:"String",
		status:"Status",
		type:"TypeSection"
	},
	InstallationStatus:{
		description:"String",
		id:"Int",
		slug:"FileStatusType"
	},
	Installation:{
		comment:"String",
		concluded_at:"String",
		grade:"Int",
		has_ampera:"Boolean",
		has_ampera_activated:"Boolean",
		has_minimal_projects:"Boolean",
		id:"String",
		new_journey:"Boolean",
		plant_id:"String",
		plant_url:"String",
		project_id:"String",
		project_name:"String",
		sections:"Section",
		status:"InstallationStatus",
		installed_inverters:"InstalledInverters",
		stage:"Int",
		stage_updated_at:"String",
		stage_error:"String",
		stage_customer_phone:"String"
	},
	BiometricValidationResponse:{
		reason:"BiometricValidationReason",
		retry_after_seconds:"Int",
		retry_at:"String",
		status:"BiometricValidationStatus"
	},
	ValidateTotalInvertersPowerResponse:{
		is_valid:"Boolean",
		error:"String"
	},
	ValidateHardwareFormPricePerWatt:{
		is_valid:"Boolean",
		is_under_expected:"Boolean",
		is_over_expected:"Boolean"
	},
	ValidateHardwareFormSystemPower:{
		is_valid:"Boolean"
	},
	ValidateHardwareFormModules:{
		price_per_watt:"ValidateHardwareFormPricePerWatt",
		system_power:"ValidateHardwareFormSystemPower"
	},
	ValidateHardwareFormOverload:{
		is_valid:"Boolean",
		is_under_expected:"Boolean",
		is_over_expected:"Boolean"
	},
	ValidateHardwareFormInverters:{
		overload:"ValidateHardwareFormOverload"
	},
	ValidateHardwareFormCapacity:{
		is_valid:"Boolean",
		is_under_expected:"Boolean",
		is_over_expected:"Boolean"
	},
	ValidateHardwareFormBatteries:{
		capacity:"ValidateHardwareFormCapacity"
	},
	ValidateHardwareFormHardware:{
		modules:"ValidateHardwareFormModules",
		inverters:"ValidateHardwareFormInverters",
		batteries:"ValidateHardwareFormBatteries"
	},
	HardwareFormValidation:{
		is_valid:"Boolean",
		hardware:"ValidateHardwareFormHardware"
	},
	HardwareFormShowcaseResponse:{
		overload_is_valid:"Boolean",
		price_per_watt_is_valid:"Boolean",
		percentage_of_service_with_combo_is_valid:"Boolean"
	},
	MirrorStatus:{
		status:"MirrorStatuses"
	},
	MirrorUploadResponse:{
		id:"String",
		url:"String"
	},
	CreatedInstalledInverter:{
		id:"ID",
		installation_id:"String",
		brand:"String",
		model:"String",
		power_kw:"Float",
		serial_number:"String",
		entry_mode:"String",
		status:"InstalledInverterStatus"
	},
	UploadInstallationLabelsResponse:{
		inverter_label_file:"String",
		inverter_label_file_url:"String",
		datalogger_label_file:"String",
		datalogger_label_file_url:"String"
	},
	InstalledInverters:{
		status:"InstalledInverterGlobalStatus",
		inverters:"InstalledInverter"
	},
	InstalledInverter:{
		id:"ID",
		model:"String",
		brand:"String",
		power_kw:"Float",
		serial_number:"String",
		datalogger_serial_number:"String",
		status:"InstalledInverterStatus",
		entry_mode:"String",
		created_at:"String",
		updated_at:"String"
	},
	CommissioningCheckResponse:{
		checked_at:"String",
		status:"CommissioningCheckStatus",
		access_user:"String"
	},
	InverterBrands:{
		brands:"String"
	},
	AvailableOrderKitItemCategory:{
		id:"Int",
		description:"String"
	},
	AvailableOrderKitItem:{
		item_id:"String",
		description:"String",
		quantity:"Int",
		value:"Float",
		type:"String",
		power:"Float",
		category:"AvailableOrderKitItemCategory"
	},
	AvailableOrderKitChannel:{
		channel:"String",
		source:"String"
	},
	AvailableOrderKitCustomer:{
		type:"String",
		document_number:"String",
		name:"String",
		phone:"String",
		email:"String",
		billing_type:"String",
		street:"String",
		number:"String",
		neighborhood:"String",
		city:"String",
		state:"String",
		ibge_code:"String",
		zip_code:"String",
		complement:"String"
	},
	AvailableOrderKitShipping:{
		freight_type:"String",
		freight_value:"Float",
		recipient_name:"String",
		recipient_phone:"String",
		recipient_email:"String",
		rural_zone:"Boolean",
		street:"String",
		number:"String",
		neighborhood:"String",
		city:"String",
		state:"String",
		ibge_code:"String",
		zip_code:"String",
		complement:"String"
	},
	AvailableOrderKitUser:{
		partner_id:"Int",
		partner_cnpj:"String",
		user_id:"Int"
	},
	AvailableOrderKitPayment:{
		origin:"String",
		value:"Float",
		installments:"Int"
	},
	AvailableOrderKit:{
		error:"String",
		id:"String",
		order_number:"Int",
		legacy_id:"Int",
		cart_id:"String",
		type:"String",
		category:"String",
		created_at:"String",
		region:"String",
		dc_id:"Int",
		reservation_id:"String",
		raw_value:"Float",
		total_value:"Float",
		items:"AvailableOrderKitItem",
		channel:"AvailableOrderKitChannel",
		customer:"AvailableOrderKitCustomer",
		shipping:"AvailableOrderKitShipping",
		user:"AvailableOrderKitUser",
		payment:"AvailableOrderKitPayment",
		status:"JSON",
		erp_code:"String",
		erp_branch:"String",
		summary:"JSON",
		expires_at:"String"
	},
	AvailableOrder:{
		order_id:"Int",
		value:"String",
		created_at:"String",
		expire_at:"String",
		kit:"AvailableOrderKit"
	},
	AvailableOrdersPagination:{
		page:"Int",
		page_size:"Int",
		total:"Int",
		has_next:"Boolean"
	},
	AvailableOrders:{
		data:"AvailableOrder",
		pagination:"AvailableOrdersPagination"
	},
	CommissioningInstalledInverter:{
		id:"ID",
		serial_number:"String",
		status:"String"
	},
	CommissioningMonitoring:{
		id:"ID",
		brand:"String",
		status:"String",
		installed_inverters:"CommissioningInstalledInverter"
	},
	CommissioningRequestData:{
		installation_id:"ID",
		code:"String",
		monitorings:"CommissioningMonitoring"
	},
	CommissioningRequestResponse:{
		success:"Boolean",
		message:"String",
		data:"CommissioningRequestData"
	},
	CommissioningResetData:{
		project_id:"ID",
		installation_id:"ID",
		removed_monitorings:"Int",
		removed_inverters:"Int",
		code:"String"
	},
	CommissioningResetResponse:{
		success:"Boolean",
		message:"String",
		data:"CommissioningResetData"
	},
	CommissioningStatusInstalledInverter:{
		id:"ID",
		serial_number:"String",
		model:"String",
		power_kw:"Float",
		status:"InstalledInverterStatus"
	},
	CommissioningStatusMonitoring:{
		brand:"String",
		status:"CommissioningMonitoringStatus",
		plant_name:"String",
		commissioning_failure_reason:"CommissioningFailureReason",
		installed_inverters:"CommissioningStatusInstalledInverter"
	},
	CommissioningStatusCustomerValidationRequest:{
		id:"ID",
		status:"String",
		attempt_number:"Int",
		initiated_at:"String"
	},
	CommissioningStatusData:{
		installation_id:"ID",
		installation_status:"CommissioningInstallationStatus",
		access_user:"String",
		monitorings:"CommissioningStatusMonitoring",
		customer_validation_requests:"CommissioningStatusCustomerValidationRequest"
	},
	CommissioningStatusResponse:{
		success:"Boolean",
		message:"String",
		data:"CommissioningStatusData"
	},
	LegacyFinancing:{
		projectId:"String",
		financingId:"Int",
		formalizedAt:"String",
		stage:"String",
		status:"String"
	},
	NotificationData:{
		id:"Int",
		clickedAt:"String",
		readAt:"String",
		createdAt:"String",
		notification:"Notification"
	},
	Notification:{
		actionUrl:"String",
		templateName:"String",
		message:"String",
		title:"String"
	},
	Metrics:{
		totalCount:"Int",
		totalUnreadCount:"Int",
		totalUnclickedCount:"Int"
	},
	NotificationsList:{
		count:"Int",
		totalCount:"Int",
		nextCursor:"String",
		nextPage:"String",
		previousCursor:"String",
		previousPage:"String",
		data:"NotificationData",
		metrics:"Metrics"
	},
	ContactPartner:{
		phone:"String",
		email:"String"
	},
	Address:{
		street:"String",
		number:"String",
		complement:"String",
		reference:"String",
		district:"String",
		zipcode:"String",
		city:"String",
		state:"String"
	},
	ResponsiblePartner:{
		username:"String",
		profile:"String",
		fullname:"String",
		document:"String",
		birthdate:"String",
		active:"Boolean",
		contact:"ContactPartner"
	},
	Permission:{
		store:"Boolean",
		financing:"Boolean"
	},
	Sfplus:{
		level:"Int",
		is_level_black:"Boolean",
		next_transition_date:"String",
		score:"Score",
		black_status:"LevelBlackStatus",
		downgrade:"Downgrade"
	},
	OnlyPartner:{
		id:"Int",
		corporate_name:"String",
		trade_name:"String",
		document:"String",
		category:"String",
		state_registration:"String",
		active:"Boolean",
		operation_term_accepted:"Boolean",
		address:"Address",
		responsible:"ResponsiblePartner",
		permission:"Permission",
		sfplus:"Sfplus",
		blocklist:"PartnerBlocklist",
		registration_type:"String"
	},
	PartnerBlocklist:{
		is_blocked:"Boolean",
		nature:"String",
		title:"String",
		description:"String",
		action:"String"
	},
	CorePartner:{
		id:"Int",
		cnpj:"String",
		responsible:"CoreParterResponsible",
		company_name:"String",
		fantasy_name:"String",
		status:"CoreParterStatus"
	},
	CoreParterResponsible:{
		id:"Int",
		full_name:"String"
	},
	CoreParterStatus:{
		active:"Boolean",
		reason:"String",
		date:"String"
	},
	PaymentCurrentIssuanceModel:{
		payout_options:"String",
		best_payout_option:"String"
	},
	ProjectProposal:{
		value_changed:"Boolean"
	},
	AppliedModifierOption:{
		type:"String",
		value:"String"
	},
	AppliedModifier:{
		name:"String",
		type:"String",
		options:"AppliedModifierOption"
	},
	AddonProduct:{
		id:"ID",
		product_name:"String",
		product_external_id:"String",
		simulation_id:"String",
		type:"String",
		product_slug:"String",
		applied:"Boolean",
		partner_commission:"Float",
		installment_price:"Float",
		total_price:"Float",
		monthly_interest_rate:"Float",
		engine_simulation_id:"String",
		previous_engine_simulation_id:"String",
		cet:"Float",
		applied_modifiers:"AppliedModifier",
		addon_type:"String"
	},
	SelectedInstallments:{
		cet:"String",
		iof:"Float",
		ipca:"String",
		addons:"AddonProduct",
		aggregated_addons:"AddonProduct",
		user_id:"Int",
		document:"String",
		is_combo:"Boolean",
		commission:"Float",
		partner_id:"Int",
		aliquot_iof:"Float",
		new_journey:"Boolean",
		person_type:"String",
		down_payment:"Float",
		due_day:"Int",
		first_due_date:"String",
		grace_period:"Int",
		installments:"Int",
		project_name:"String",
		system_power:"Float",
		interest_rate:"Float",
		cet_percentage:"Float",
		commission_raw:"Float",
		financing_value:"Float",
		taxa_de_cadastro:"Float",
		taxa_de_juros:"Float",
		installment_value:"Float",
		is_from_suggested:"Boolean",
		registration_fee_gross:"Float",
		registration_fee_raw_dry:"Float",
		registration_fee_raw_final:"Float",
		is_combo_connect:"Boolean"
	},
	RiskInfo:{
		title:"String",
		description:"String",
		todo:"String",
		reason:"String",
		decision:"Int"
	},
	BNPL:{
		decision_pre_analysis:"Int",
		min_entry_value:"Float",
		max_installments:"Int",
		pre_approved_value:"Float",
		status:"String"
	},
	Guarantor:{
		id:"String",
		document:"String",
		birth_date:"String",
		border_line:"Boolean",
		created_at:"String",
		customer_second_financing_policy:"Boolean",
		decision_pre_analysis:"Int",
		max_approved_project_value:"Float",
		max_financing_value:"Float",
		max_grace_period:"Int",
		max_installments:"Int",
		min_approved_project_value:"Float",
		min_installment_value:"Float",
		pre_approved_value:"Float",
		project_name:"String",
		project_state:"String",
		risk_class:"String",
		status:"String"
	},
	InstallmentsConditions:{
		suggested_installments:"Int",
		suggested_installments_value:"Float"
	},
	Project:{
		id:"ID",
		user_id:"Int",
		partner_id:"Int",
		person_type:"String",
		document:"String",
		created_at:"String",
		representative_document:"String",
		project_value:"Float",
		system_power:"Float",
		system_type:"String",
		grace_period:"Int",
		down_payment:"Float",
		status:"String",
		project_status:"String",
		min_installments:"Int",
		max_installments:"Int",
		max_grace_period:"Int",
		project_name:"String",
		project_state:"String",
		partner_profile:"String",
		pre_approved_value:"Float",
		products_applieds:"String",
		installments:"String",
		risk_info:"RiskInfo",
		state_registration:"String",
		complete:"Boolean",
		selected_installments:"SelectedInstallments",
		guarantor:"Guarantor",
		birth_date:"String",
		decision_pre_analysis:"Int",
		score_sol_facil:"Int",
		simulation_id:"String",
		addons:"AddonProduct",
		max_approved_project_value:"Float",
		min_approved_project_value:"Float",
		max_financing_value:"Float",
		border_line:"Boolean",
		is_formalized:"Boolean",
		new_journey:"Boolean",
		formalized_at:"String",
		shopping_cart_id:"String",
		bnpl:"BNPL",
		bnpl_simulation_id:"String",
		bnpl_status:"String",
		is_onflex_partner:"Boolean",
		is_turbo_prime:"Boolean",
		can_select_ampera:"Boolean",
		has_energy_bill_analysis:"Boolean",
		insurance_commission:"Float",
		gained_points:"Int",
		original_installment_value:"Float",
		is_contract_signed:"Boolean",
		commission:"Float",
		risk_class:"String",
		selected_installment:"Float",
		credit_analysis_status:"String",
		bill_value:"Float",
		installments_conditions:"InstallmentsConditions"
	},
	ProjectProposalUpdateResponse:{
		engine_simulation_id:"String",
		simulation_id:"String",
		project_id:"String",
		is_combo:"Boolean",
		is_ampera:"Boolean",
		commission:"Int",
		applied_addons:"String"
	},
	IsComboResponse:{
		data:"Boolean"
	},
	ProjectCreateResponse:{
		status:"ProjectCreateStatus",
		id:"ID"
	},
	PartnerOverviewAll:{
		total:"Int",
		in_progress:"Int",
		in_reassassement:"Int",
		finish:"Int",
		canceled:"Int",
		expired:"Int"
	},
	PartnerOverviewSimulation:{
		total:"Int",
		approved:"Int",
		reassassement:"Int",
		canceled:"Int",
		expired:"Int"
	},
	PartnerOverviewProposal:{
		total:"Int",
		in_equipments:"Int",
		in_customer_data:"Int",
		in_biometry_and_contract:"Int",
		in_payment_model:"Int",
		canceled:"Int",
		expired:"Int"
	},
	PartnerOverviewInstallation:{
		total:"Int",
		in_progress:"Int",
		canceled:"Int",
		expired:"Int"
	},
	PartnerOverview:{
		partner_id:"Int",
		all:"PartnerOverviewAll",
		simulation:"PartnerOverviewSimulation",
		proposal:"PartnerOverviewProposal",
		installation:"PartnerOverviewInstallation",
		status:"String",
		last_updated_at:"String",
		next_update_at:"String"
	},
	RegistrationContact:{
		email:"String",
		phone:"String"
	},
	RegistrationAddressCity:{
		id:"Int",
		name:"String"
	},
	RegistrationAddressState:{
		id:"Int",
		name:"String"
	},
	RegistrationElectricityBill:{
		holder_cpf:"String",
		is_under_customer_name:"Boolean",
		distributor_id:"Int",
		inverters_power_above_limit:"Boolean"
	},
	RegistrationElectricityBillWithDocuments:{
		id:"ID",
		holder_cpf:"String",
		is_under_customer_name:"Boolean",
		documents:"RegistrationDocument"
	},
	RegistrationDocument:{
		type:"RegistrationDocumentTypes",
		status:"String",
		filename:"String",
		url_download:"String",
		url_preview:"String",
		mime_type:"String",
		docstorage_id:"String",
		id:"String"
	},
	RegistrationAddress:{
		zipcode:"String",
		street:"String",
		street_number:"String",
		complement:"String",
		neighborhood:"String",
		city_id:"Int",
		state_id:"Int",
		city:"RegistrationAddressCity",
		state:"RegistrationAddressState",
		is_rural:"Boolean"
	},
	RegistrationProject:{
		address:"RegistrationAddress",
		documents:"RegistrationDocument",
		electricity_bill:"RegistrationElectricityBill",
		residencial_is_the_same_of_plant:"Boolean",
		comment:"String"
	},
	RegistrationCustomer:{
		cpf:"String",
		full_name:"String",
		birthdate:"String",
		contact:"RegistrationContact",
		documents:"RegistrationDocument",
		document_type:"RegistrationDocumentModel",
		address:"RegistrationAddress"
	},
	RegistrationCompany:{
		company_name:"String",
		cnpj:"String",
		contact:"RegistrationContact",
		documents:"RegistrationDocument",
		majority_partner:"RegistrationCompanyMajorityPartner",
		legal_representatives:"RegistrationLegalRepresentative",
		majority_partner_is_legal_representative:"Boolean",
		is_only_one_legal_representative:"Boolean"
	},
	RegistrationLegalRepresentative:{
		cpf:"String",
		full_name:"String",
		birthdate:"String",
		contact:"RegistrationContact",
		documents:"RegistrationDocument",
		address:"RegistrationAddress",
		kind:"RegistrationRepresentantTypes",
		document_type:"RegistrationDocumentModel"
	},
	RegistrationCompanyMajorityPartner:{
		cpf:"String",
		is_legal_representative:"Boolean",
		full_name:"String",
		birthdate:"String",
		contact:"RegistrationContact",
		documents:"RegistrationDocument",
		address:"RegistrationAddress",
		document_type:"RegistrationDocumentModel"
	},
	RegistrationGuarantor:{
		cpf:"String",
		full_name:"String",
		birthdate:"String",
		contact:"RegistrationContact",
		documents:"RegistrationDocument",
		address:"RegistrationAddress",
		document_type:"RegistrationDocumentModel"
	},
	RegistrationError:{
		title:"String",
		description:"String",
		field:"String",
		type:"String"
	},
	RegistrationDetailsResponse:{
		project_id:"String",
		status:"String",
		is_combo:"Boolean",
		remaining_changes_after_confirmation:"Int",
		person_type:"RegistrationPersonType",
		customer:"RegistrationCustomer",
		company:"RegistrationCompany",
		guarantor:"RegistrationGuarantor",
		project:"RegistrationProject",
		errors:"RegistrationError",
		electricity_bills:"RegistrationElectricityBillWithDocuments",
		has_other_beneficiary_units:"Boolean"
	},
	RegistrationGridAccessApproval:{
		display_mode:"GridAccessApprovalDisplayMode"
	},
	RevalidationStatusCount:{
		status:"String",
		count:"Int"
	},
	RevalidationBrandSummary:{
		brand:"String",
		total:"Int",
		statuses:"RevalidationStatusCount"
	},
	RevalidationSummary:{
		total:"Int",
		statuses:"RevalidationStatusCount",
		brands:"RevalidationBrandSummary"
	},
	LatestSubmission:{
		serial_number:"String",
		attempt_status:"AttemptStatus"
	},
	LatestAttempt:{
		serial_number:"String",
		attempt_status:"AttemptStatus",
		brand:"String",
		submitted_at:"String",
		processed_at:"String",
		reason_code:"String"
	},
	RevalidationItem:{
		revalidation_id:"String",
		status:"RevalidationStatus",
		project_name:"String",
		plant_name:"String",
		reference_inverter_brand:"String",
		expected_total_inverters:"Int",
		latest_submission:"LatestSubmission",
		latest_attempts:"LatestAttempt"
	},
	RevalidationPagination:{
		page:"Int",
		page_size:"Int",
		total_items:"Int",
		total_pages:"Int"
	},
	RevalidationsListResponse:{
		items:"RevalidationItem",
		pagination:"RevalidationPagination"
	},
	RegisterRevalidationCredentialResponse:{
		success:"Boolean",
		message:"RegisterRevalidationCredentialErrorCode"
	},
	RevalidationSubmissionAccepted:{
		revalidation_id:"String",
		submission_number:"Int",
		total_devices:"Int",
		revalidation_status:"RevalidationStatus"
	},
	RevalidationSubmissionError:{
		code:"String",
		detail:"String"
	},
	RevalidationSubmissionDevice:{
		brand:"String",
		serial_number:"String"
	},
	RevalidationSubmissionRejected:{
		revalidation_id:"String",
		errors:"RevalidationSubmissionError",
		devices:"RevalidationSubmissionDevice"
	},
	RevalidationSubmissionReferenceBrandUpdated:{
		revalidation_id:"String",
		reference_inverter_brand:"String",
		revalidation_status:"RevalidationStatus"
	},
	RevalidationSubmissionsData:{
		accepted:"RevalidationSubmissionAccepted",
		rejected:"RevalidationSubmissionRejected",
		reference_brand_updated:"RevalidationSubmissionReferenceBrandUpdated"
	},
	SubmitRevalidationsResponse:{
		success:"Boolean",
		message:"String",
		data:"RevalidationSubmissionsData"
	},
	EnergyBillAnalysisDecision:{
		decision:"String",
		details:"String"
	},
	GetOpportunitiesResponse:{
		addons_opportunities:"AddonsOpportunities",
		financing_gained_points:"Int"
	},
	AddonsOpportunities:{
		addon_type:"String",
		gained_points:"Int",
		product_slug:"String"
	},
	LevelBlackStatus:{
		kwGoalMonth:"Int",
		kwReachedMonth:"Int"
	},
	Contact:{
		landline:"String",
		mobile:"String",
		email:"String"
	},
	Responsible:{
		id:"Int",
		username:"String",
		profile:"String",
		fullname:"String",
		document:"String",
		birthdate:"String",
		active:"Boolean",
		created_at:"String",
		contact:"Contact",
		partner:"Partner"
	},
	Score:{
		current:"Int",
		goal:"Int"
	},
	Downgrade:{
		has_risk:"Boolean"
	},
	Partner:{
		id:"Int",
		corporate_name:"String",
		operation_term_accepted:"Boolean",
		trade_name:"String",
		document:"String",
		category:"String",
		state_registration:"String",
		active:"Boolean",
		created_at:"String",
		address:"Address",
		responsible:"Responsible",
		permission:"Permission",
		users:"User",
		sfplus:"Sfplus"
	},
	Post:{
		id:"Int",
		title:"String",
		body:"String",
		userId:"String",
		comments:"Comment"
	},
	Comment:{
		id:"Int",
		name:"String",
		email:"String",
		body:"String"
	},
	OperatingAgreement:{
		is_current_term_accepted:"Boolean",
		can_accept:"Boolean"
	},
	UserTerms:{
		operating_agreement:"OperatingAgreement"
	},
	User:{
		id:"Int",
		username:"String",
		profile:"String",
		fullname:"String",
		document:"String",
		birthdate:"String",
		active:"Boolean",
		created_at:"String",
		contact:"Contact",
		partner:"Partner",
		posts:"Post",
		terms:"UserTerms"
	},
	WalletPaymentModelSummary:{
		state:"String",
		current_model:"String",
		upfront_percentage:"Int",
		after_completion_percentage:"Int",
		performance_percentage:"Int",
		disabled_model:"String",
		disabled_reason:"String",
		novice_completed:"Int",
		total_completed:"Int",
		on_time_completed:"Int",
		next_model:"String",
		projects_needed_for_next_model:"Int",
		is_blocked:"Boolean",
		block_reason:"String",
		updated_at:"String"
	},
	WalletPaymentModelCard:{
		key:"String",
		upfront_percentage:"Int",
		after_completion_percentage:"Int",
		min_on_time_percentage:"Int",
		is_current:"Boolean",
		state:"String",
		requirements:"WalletModelRequirement"
	},
	WalletModelRequirement:{
		code:"String",
		is_met:"Boolean",
		is_waived:"Boolean"
	},
	WalletDefaultModelCondition:{
		code:"String",
		value:"Int"
	},
	WalletPaymentPerformance:{
		total_completed:"Int",
		on_time_completed:"Int",
		late_completed:"Int",
		on_time_percentage:"Int",
		thresholds:"WalletPerformanceThresholds",
		challenge:"WalletPerformanceChallenge",
		by_kit_type:"WalletPerformanceByKitType"
	},
	WalletPerformanceThresholds:{
		model_b:"Int",
		model_a:"Int"
	},
	WalletPerformanceChallenge:{
		target_model:"String",
		projects_needed:"Int"
	},
	WalletPerformanceByKitType:{
		kit_type:"String",
		on_time_count:"Int",
		late_count:"Int",
		projects_filter:"WalletProjectsFilter"
	},
	WalletProjectsFilter:{
		kit_type:"String",
		status:"String"
	},
	WalletCommercialException:{
		is_active:"Boolean"
	},
	WalletEligibilityContext:{
		partner_profile:"String",
		is_novice:"Boolean",
		novice_completed:"Int",
		novice_required:"Int",
		performance_model:"String",
		delinquency_status:"String",
		commercial_exception:"WalletCommercialException"
	},
	WalletPaymentModel:{
		summary:"WalletPaymentModelSummary",
		models:"WalletPaymentModelCard",
		default_model_conditions:"WalletDefaultModelCondition",
		performance:"WalletPaymentPerformance",
		eligibility_context:"WalletEligibilityContext"
	}
}

export const Ops = {
query: "Query" as const,
	mutation: "Mutation" as const
}